import KnowledgePage from './KnowledgePage';

export default KnowledgePage;